import React from 'react';

import { IbanElement } from '@stripe/react-stripe-js';
import type { StripeIbanElementChangeEvent } from '@stripe/stripe-js';

import { isDarkModeApplied } from '#src/app/shared/hooks/dom';
import { useCountryCode } from '#src/app/shared/hooks/l10n';
import { stripeElementDomId } from '#src/app/shared/utils/payments';

type Props = {
	onChange?: (event: StripeIbanElementChangeEvent) => unknown;
	onFocus?: () => void;
	onBlur?: () => void;
};

export const IbanElementWrapper: React.FC<Props> = (props) => {
	const countryCode = useCountryCode();
	const isDarkMode = isDarkModeApplied();

	return (
		<IbanElement
			id={stripeElementDomId('iban')}
			{...props}
			options={{
				supportedCountries: ['SEPA'],
				placeholderCountry: countryCode,
				hideIcon: true,
				style: {
					base: {
						fontSize: '16px',
						color: isDarkMode ? '#ffffff' : '#2d2f37',
						'::placeholder': {
							color: isDarkMode ? '#cbcfda' : 'rgba(58, 62, 73, 0.8)',
						},
					},
					invalid: {
						color: isDarkMode ? '#ffe4e9' : '#910a21',
					},
				},
			}}
		/>
	);
};
